<template>
  <div>
    <div class="itemtitle">{{ $t('lang.applyDetail.applyDetail') }}</div>
    <div class="filelist">
      <el-row class="rowheader">
        <el-col :span="8" style="text-align: center; padding-left: 15px">{{ $t('lang.applyDetail.certType') }}</el-col>
        <el-col :span="8" style="text-align: center">{{ $t('lang.applyDetail.certName') }}</el-col>
        <el-col :span="8" style="text-align: center">{{ $t('lang.applyDetail.operation') }}</el-col>
      </el-row>
      <el-row class="filerow" v-for="(item, index) in fileList" :key="'detail_' + index">
        <el-col :span="8" style="text-align: center; padding-left: 15px">
          {{ certTypeNameFormatter(item.certTypeCode) }}
        </el-col>
        <el-col :span="8" style="text-align: center">
          {{ isZh ? item.certChineseName : item.certEnglishName }}
        </el-col>
        <el-col :span="8" style="text-align: center">
          <el-tooltip v-if="item.unableIssue === 'Y'"
                      class="item"
                      effect="dark"
                      :content="item.unableIssueReason"
                      placement="top-start">
            <el-button size="mini" type="text">
              {{ $t('lang.applyList.operations.unableIssue') }}
              <i class="el-icon-info"></i>
            </el-button>
          </el-tooltip>
          <el-button size="mini" type="text" v-if="item.electronicVersionFile"
                     @click="downloadElectronicVersionFile(item.electronicVersionFile)">
            {{ $t('lang.applyDetail.downloadElectronicVersionFile') }}
            <i class="icon iconfont icon-xiangxiajiantou-s"></i>
          </el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { downloadFile, listDictByType } from '@/api/base'
import { mapGetters } from 'vuex'
import languageType from '@/locales/languageType'

export default {
  name: 'electronicApplyDetail',
  props: {
    applyVo: {
      type: Object
    }
  },
  data () {
    return {
      certTypeDict: []
    }
  },
  computed: {
    ...mapGetters([
      'currentLanguage'
    ]),
    fileList: function () {
      return this.applyVo.packVoList[0].detailVoList
    },
    isZh: function () {
      return this.currentLanguage === languageType.zh.code
    }
  },
  mounted () {
    this.loadCertTypeDict()
  },
  methods: {
    loadCertTypeDict () {
      listDictByType({
        type: 'CERT_TYPE'
      }).then(res => {
        this.certTypeDict = res.data
      })
    },
    certTypeNameFormatter (val) {
      const dict = this.certTypeDict.filter(dict => dict.code === val)[0]
      if (dict) {
        return this.isZh ? dict.chineseName : dict.englishName
      }
      return ''
    },
    downloadElectronicVersionFile (file) {
      downloadFile(file)
    }
  }
}
</script>

<style scoped>
.itemtitle {
  background: #a2100e;
  color: #fff;
  text-align: center;
  height: 35px;
  line-height: 35px;
  box-shadow: -1px 3px 11px 2px rgb(136 136 136 / 51%);
}

.filelist .rowheader {
  font-size: 12px;
  color: #a2100e;
  padding: 10px 0 5px 0;
}

.filelist .filerow {
  margin: 5px 0;
  font-size: 12px;
  line-height: 35px;
  color: #707070;
}

.filelist .filerow:nth-child(even) {
  background: #ededed;
}

/deep/ .el-button--text {
  color: #606266;
}

/deep/ .el-button--text i {
  color: #a2100e;
  margin-left: 5px;
  font-size: 18px;
}

/deep/ .el-button--text span {
  display: flex;
  align-items: center;
}
</style>
